import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { Link } from 'react-router-dom';

import CustomLoadingOverlay from '../../shared/component/customLoadingOverlay';
import AddMeetingForm from './addMeetingForm';
import { DateTimeFormatter } from '../../shared/controls/formatters';
import MeetingList from '../../assets/json/dummyDropDown.json';
import { getMeetingsList } from '../../redux/selector';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../shared/component/Loader';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import { meetingInputData } from '../../shared/constants';

const OptionButton = ({ handleClickOpenEditForm, paramsValue }) => {
  return (
    <div className="action-menu">
      <img
        src="/assets/images/edit.png"
        className="action-img1"
        onClick={() => handleClickOpenEditForm(paramsValue)}
        alt="Edit Meeting"
        title="Edit Meeting"
      ></img>

      <Link to="/meetings/viewMeetings">
        <img
          src="/assets/images/view.png"
          className="action-img2"
          alt="View Meeting"
          title="View Meeting"
        ></img>
      </Link>
    </div>
  );
};

const initialValue = {
  meetingName: '',
  meetingId: '',
  location: '',
  fromDateTime: '',
  toDateTime: '',
  host: '',
  participants: '',
  relatedTo: '',
  repeat: '',
  reminder: '',
  description: '',
  createdBySystem: '',
  createdBySystemId: '',
  modifiedBySystem: '',
  modifiedBySystemId: '',
};

const Meetings = () => {
  const stateData = useSelector((state) => state);
  const meetings = useSelector(getMeetingsList);
  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(stateData, 'meetingsList');

  const themeValue = localStorage.getItem('selectedGridTheme');
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [selectedTheme, setSelectedTheme] = useState(themeValue ? themeValue : 'alpine');
  const [gridLoading, setGridLoading] = useState(false);
  const gridRef = useRef();
  const [open, setOpen] = React.useState(false);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [rowData, setRowData] = useState(meetings);
  const [MeetingsData, setMeetingsData] = useState(meetings && meetings.length > 0 ? meetings : []);
  const [loading, setLoading] = useState(storeLoading);
  const [updateListFlag, setUpdateListFlag] = useState(false);

  useEffect(() => {
    if (meetings && meetings.length === 0) {
      setUpdateListFlag(true);
    } else {
      setRowData(meetings);
    }
  }, []);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    // Check if assignments contain data
    if (meetings && meetings.length > 0) {
      setRowData(meetings);
    } else {
      setRowData([]);
    }
  }, [meetings]);

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: 'Actions',
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <OptionButton
            rowData={paramsValue}
            openPopup={open}
            handleClickOpenEditForm={() => handleClickOpenEditForm(paramsValue)}
          />
        );
      },
      maxWidth: 120,
      sortable: false,
      filter: false,
    },

    {
      headerName: 'Meeting Name',
      field: 'name',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'From',
      field: 'from',
      valueFormatter: DateTimeFormatter,
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'To',
      field: 'to',
      valueFormatter: DateTimeFormatter,
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Related To',
      field: 'relatedTo',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },

    {
      headerName: 'Host',
      field: 'host',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Reminder',
      field: 'reminder',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Participants',
      field: 'participants',
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
      valueGetter: (params) => {
        // Map through participantsList and return contactName values joined with a comma
        if (params.data.participantsList && params.data.participantsList.length > 0) {
          return params.data.participantsList
            .map((participant) => participant.contactName)
            .join(', ');
        }
        return ''; // Return empty string if no participants
      },
    },
    {
      headerName: 'Created By',
      field: 'createdBy',
      minWidth: 230,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Updated By',
      field: 'updatedBy',
      minWidth: 230,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
  ]);

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        { statusPanel: 'agTotalRowCountComponent', align: 'center' },
        { statusPanel: 'agFilteredRowCountComponent' },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agAggregationComponent' },
      ],
    };
  }, []);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const popupParent = useMemo(() => {
    return document.body;
  }, []);

  const sortingOrder = useMemo(() => {
    return ['desc', 'asc', null];
  }, []);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: true,
    enableValue: true,
    enablePivot: true,
  }));

  const refresh = () => {
    setGridLoading(true);
  };

  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setQuickFilter(document.getElementById('filter-text-box').value);
  }, []);

  // const handleThemeChange = (event) => {
  //   setSelectedTheme(event.target.value);
  //   localStorage.setItem("selectedGridTheme", event.target.value);
  //   const selectedTheme = localStorage.getItem("selectedTheme");
  //   const userInformation = JSON.parse(localStorage.getItem("userInformation"));
  //   const data = {
  //     userId: userInformation?.userId,
  //     theme: selectedTheme,
  //     agGridTheme: event.target.value,
  //   };
  // };

  const handleFormSubmit = (formData) => {
    console.log(formData);
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  const handleOpenAddForm = () => {
    const updatedObject = {
      ...initialValue,
      type: 'add',
    };
    setMeetingsData(updatedObject);
    setOpen(true);
  };

  const handleClickOpenEditForm = (paramsValue) => {
    const updatedObject = {
      ...paramsValue,
      type: 'edit',
    };
    setMeetingsData(updatedObject);
    setOpen(true);
  };

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage();
  }, []);

  const cellClickedListener = useCallback((event) => {}, []);
  const handleCloseAddForm = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (updateListFlag) {
      const columnName = updateListFlag === false ? 'name' : 'UpdatedDateTime';
      const orderType = updateListFlag === false ? 'asc' : 'desc';
      const data = {
        ColumnName: columnName,
        OrderType: orderType,
        PageNumber: 1,
        PageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
      };
      setUpdateListFlag(false);
      dispatch(fetchDataAndUpdateStore({ key: 'meetingsList', inputData: meetingInputData }));
    }
  }, [dispatch, updateListFlag]);

  return (
    <>
      {loading && <Loader />}
      <div className="inner-page" style={containerStyle}>
        <div className="dash-container">
          <div className="tbl_container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="main-hd">
                  <div className="pagetitle">
                    <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                    Meetings
                  </div>

                  <div className="third-div">
                    <img
                      className="refresh-btn"
                      src="/assets/images/refresh.svg"
                      alt="Refresh"
                      onClick={refresh}
                    />
                    <div className="heading_item">
                      <input
                        className="form-control"
                        id="filter-text-box"
                        type="Text"
                        placeholder="Search in Deals..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                    {/* <div className="heading_item select_optn">
                      <label>Theme Change:</label>
                      <select
                        className="select-div"
                        value={selectedTheme}
                        onChange={handleThemeChange}
                      >
                        <option value="alpine">Alpine</option>
                        <option value="balham">Balham</option>
                        <option value="material">Material</option>
                      </select>
                    </div> */}

                    <div className="heading_item">
                      <button className="add-btn" type="button" onClick={handleOpenAddForm}>
                        Create Meeting
                      </button>
                      {open && (
                        <div className={`overlay ${isOverlayVisible ? 'visible' : ''}`}>
                          {' '}
                          <AddMeetingForm
                            handleCloseAddForm={handleCloseAddForm}
                            handleFormSubmit={handleFormSubmit}
                            handleClickOpenEditForm={handleClickOpenEditForm}
                            meetingsData={MeetingsData}
                            open={open}
                            meetingList={MeetingList}
                          />{' '}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="cutome_ag_theme">
                  <div
                    className={`ag-theme-${selectedTheme} tbl_height`}
                    style={{ width: '100%', height: `100%` }}
                  >
                    {gridLoading ? (
                      <CustomLoadingOverlay loadingMessage="Loading..." />
                    ) : (
                      <AgGridReact
                        className="ag-grid-container" // Add a class for styling
                        domLayout="fixedHeight"
                        ref={gridRef} // Ref for accessing Grid's API
                        rowData={rowData} // Row Data for Row
                        columnDefs={columnDefs}
                        autoGroupColumnDef={autoGroupColumnDef}
                        defaultColDef={defaultColDef} // Default Column Properties
                        overlayLoadingTemplate={`<Loader />`}
                        animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                        rowSelection={'multiple'} // Options - allows click selection of rows
                        statusBar={statusBar}
                        sideBar={sideBar} // pass side by making interface
                        enableRangeSelection={true}
                        suppressExcelExport={true}
                        suppressRowClickSelection={true}
                        groupSelectsChildren={true}
                        pivotPanelShow={'always'}
                        popupParent={popupParent}
                        sortingOrder={sortingOrder}
                        onFirstDataRendered={onFirstDataRendered}
                        onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                        rowDragManaged={true}
                        suppressMoveWhenRowDragging={true}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Meetings;
